import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';

import toNumber from 'lodash/toNumber';
import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
import floor from 'lodash/floor';
import { FaRegEye } from 'react-icons/fa';
import { usePageViews } from 'src/utils/helper';
dayjs.extend(buddhistEra);

export const Viewer = ({ data = null }: any) => {
  const _data = toNumber(data);
  if (!isNumber(_data) || isNaN(_data) || _data < 1) return null;
  return (
    <>
      <div className='pageview'>
        <FaRegEye />
        <span> {usePageViews(floor(data, 2))} </span>
      </div>
    </>
  );
};
